export enum ScheduleType {
  Interval = "interval",
  DBT = "dbt",
  Cron = "cron",
  VisualCron = "visual_cron",
  CalendarRecurrence = "calendar_recurrence",
  Fivetran = "fivetran",
  Streaming = "streaming",
  MatchBooster = "match_booster",
  JourneyTriggered = "journey_triggered",
  IdrRun = "idr_run",
}

export enum IntervalUnit {
  Minute = "minute",
  Hour = "hour",
  Day = "day",
  Week = "week",
}

export interface Interval {
  unit: IntervalUnit;
  quantity: number;
}

export interface IntervalSchedule {
  interval: Interval;
}

export interface CronSchedule {
  expression: string;
}

export type Day =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export interface VisualCronSchedule {
  expressions: {
    time: string;
    days: Record<Day, boolean | undefined>;
  }[];
}

export interface CalendarRecurrenceSchedule {
  unit: "month";
  days: number[];
  time: string;
  overflow: "last_day";
  timezone: "UTC";
}

export const CALENDAR_RECURRENCE_TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
